import React from 'react';

export const ErrorAlt6 = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--error-alt-6';
  color = color || '#0076CC';

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M8.08919 2.01026L8.58519 1.51526C8.96024 1.14032 9.46886 0.929688 9.99919 0.929688C10.5295 0.929688 11.0381 1.14032 11.4132 1.51526L18.4842 8.58526C18.6701 8.77101 18.8177 8.99158 18.9183 9.23438C19.019 9.47718 19.0708 9.73743 19.0708 10.0003C19.0708 10.2631 19.019 10.5233 18.9183 10.7661C18.8177 11.0089 18.6701 11.2295 18.4842 11.4153L11.4142 18.4853C11.2284 18.6712 11.0079 18.8187 10.7651 18.9194C10.5223 19.02 10.262 19.0718 9.99919 19.0718C9.73636 19.0718 9.4761 19.02 9.23331 18.9194C8.99051 18.8187 8.76993 18.6712 8.58419 18.4853L1.51419 11.4153C1.32823 11.2295 1.18071 11.0089 1.08007 10.7661C0.979418 10.5233 0.927612 10.2631 0.927612 10.0003C0.927612 9.73743 0.979418 9.47718 1.08007 9.23438C1.18071 8.99158 1.32823 8.77101 1.51419 8.58526L5.04919 5.05026"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.72998V9.72998"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.73V12.74"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ErrorAlt6;
